module.exports = __webpack_public_path__ + "static/img/11.2b50938.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/13/sp/11.png
// module id = qaRJ
// module chunks = 0